/** 詳細ページのサマリー帯。ラベル + 値のミニ指標を 4〜5 枚、横一列に。 */
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import type { Tone } from "./StatusTag";
import { isUnset } from "./unset";

export type SummaryItem = {
  label: string;
  value?: ReactNode;
  /** 値が無いときの文字 */
  empty?: string;
  /** 値をリンクにする(利用者 → 従業員など) */
  href?: string;
  /** 値の色(期限超過 = danger など)。neutral / info は素の色 */
  tone?: Tone;
};

export function SummaryStrip({ items, loading = false }: { items: SummaryItem[]; loading?: boolean }) {
  return (
    <div className="ui-summary" aria-busy={loading || undefined}>
      {items.map((it) => {
        const unset = !loading && isUnset(it.value);
        const toneCls = it.tone && it.tone !== "neutral" && it.tone !== "info" ? ` is-${it.tone}` : "";
        return (
          <div className="ui-summary-cell" key={it.label}>
            <div className="ui-summary-label">{it.label}</div>
            {loading ? (
              <span className="ui-summary-skeleton" aria-hidden />
            ) : (
              <div
                className={`ui-summary-value${unset ? " is-unset" : ""}${toneCls}`}
                title={typeof it.value === "string" ? it.value : undefined}
              >
                {unset ? (it.empty ?? "未設定") : it.href ? <Link to={it.href}>{it.value}</Link> : it.value}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
